const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  batchCreate ({ state, commit, rootState }, params) {
    // 暂停实际请求，覆盖通用埋点及直接调用此 action 的下单监测，保留 Promise 契约。
    // 恢复时移除空返回，并同时启用 utils/aosAnalytics.js 中的采集和定时上报。
    // return rootState.axios.post('/opensearch/v1frontend/aos-analytics/batch-create', params, {
    //   noInterceptorError: true,
    //   noShowError: true,
    // })
    return Promise.resolve()
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
